import { useTranslation } from 'react-i18next';

export default function TrustBlock() {
  const { t } = useTranslation('home');

  const items = [
    { icon: 'ri-information-line', text: t('trust_text_1') },
    { icon: 'ri-external-link-line', text: t('trust_text_2') },
    { icon: 'ri-shield-check-line', text: t('trust_text_3') },
    { icon: 'ri-hand-heart-line', text: t('trust_text_4') },
  ];

  return (
    <section className="relative w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            {t('trust_title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
          {items.map((item, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 p-5 md:p-6 rounded-xl bg-background-100 border border-secondary-100"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                <i className={`${item.icon} text-accent-600 text-lg`}></i>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed pt-1.5">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}